import React, { useEffect, useState } from 'react';
import TextField from '../components/atoms/TextField';
import Label from '../components/atoms/Label';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/PersonalDetails.css';
import Button from '../components/atoms/Button';
import { useSelector, useDispatch } from 'react-redux';
import { updateUserDetails } from '../services/PersonalDetailsApi';
import { logger } from '../utils/logger';

const PersonalDetails = () => {
	const dispatch = useDispatch();

	// To store values from Database
	const {
		firstName: initialFirstName,
		lastName: initialLastName,
		emailId: emailId,
	} = useSelector((state) => state.userDetails);

	// To store current values
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	// Load personal details from API
	const loadPersonalDetails = () => {
		setFirstName(initialFirstName);
		setLastName(initialLastName);

		setFormValidation({
			firstName: initialFirstName.trim().length > 0,
			lastName: initialLastName.trim().length > 0,
		});
	};

	// Reset the form data
	const resetData = () => {
		setFirstName(initialFirstName);
		setLastName(initialLastName);
		setFormValidation({
			firstName: initialFirstName.trim().length > 0,
			lastName: initialLastName.trim().length > 0,
		});
		toast.success('Data has been reset!');
	};

	useEffect(() => {
		loadPersonalDetails();
	}, []);

	const [formValidation, setFormValidation] = useState({
		firstName: false,
		lastName: false,
	});

	const isFormValid = () => {
		return formValidation.firstName && formValidation.lastName;
	};

	const updateUserData = async () => {
		try {
			setIsLoading(true);
			const email = emailId;
			const updates = {
				firstName: firstName,
				lastName: lastName,
			};

			let response = await updateUserDetails(email, updates);
			if (response.success) {
				toast.success('Details updated successfully!');
			} else {
				toast.error('Error updating user details');
			}
		} catch (error) {
			logger.error('Error updating user details:', error);
			toast.error('Error updating user details');
		} finally {
			setIsLoading(false);
		}
	};

	const handleSubmit = () => {
		if (isFormValid()) {
			updateUserData();
			logger.log('Form submitted successfully!');
			logger.log('First Name:', firstName);
			logger.log('Last Name:', lastName);
		} else {
			toast.error('Please correct the errors in the form.');
			logger.log('Form has validation errors. Please correct them.');
		}
	};

	// Update the handleFieldValidation to include console logging for debugging
	const handleFieldValidation = (field, isValid) => {
		setFormValidation((prev) => {
			const updated = {
				...prev,
				[field]: isValid,
			};
			logger.log(`Field ${field} validation updated:`, isValid);
			logger.log('Current form validation:', updated);
			return updated;
		});
	};

	const validateFnameLname = (value) => {
		if (!value.trim()) {
			return 'Username is required.';
		}
		return '';
	};

	return (
		<div className="personal-details-wrapper">
			{isLoading ? (
				<div
					className="loader-container"
					style={{
						height: 'calc(100% - 60px)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div className="loader"></div>
					<p>Loading...</p>
				</div>
			) : (
				<div className="personal-details-container">
					<div className="personal-details-row1">
						<div className="personal-details-first-name">
							<Label
								label="Enter Your First Name"
								fontSize={'14px'}
								fontWeight={'400'}
								className={'display-flex'}
							/>
							<TextField
								value={firstName}
								onChange={(value) => setFirstName(value)}
								validate={(value) => validateFnameLname(value)}
								errorMessage="This field cannot be empty."
								onValidation={(isValid) =>
									handleFieldValidation('firstName', isValid)
								}
								showError={!formValidation.firstName}
							/>
						</div>
						<div className="personal-details-last-name">
							<Label
								label="Enter Your Last Name"
								fontSize={'14px'}
								fontWeight={'400'}
								className={'display-flex'}
							/>
							<TextField
								value={lastName}
								onChange={(value) => setLastName(value)}
								validate={(value) => validateFnameLname(value)}
								errorMessage="This field cannot be empty."
								onValidation={(isValid) =>
									handleFieldValidation('lastName', isValid)
								}
								showError={!formValidation.lastName}
							/>
						</div>
					</div>
					<div className="personal-details-row3">
						<Button
							label="Reset"
							onClick={resetData}
							className="personal-details-cancel-button"
						/>
						<Button
							label="Update"
							onClick={handleSubmit}
							className="personal-details-update-button"
						/>
					</div>
					<ToastContainer />
				</div>
			)}
		</div>
	);
};

export default PersonalDetails;
